/**
 * LEGACY — chỉ còn module tag cũ ở `src/components/mocules/{TagComponent,TagType}` dùng bảng này.
 *
 * Đừng thêm entry mới: style/nhãn/thứ tự của tag do CMS quyết định (xem `src/utils/TagUtils.js`
 * và `docs/product-tag-display-spec.md`). Toàn bộ entry hardcode khác đã được tắt từ
 * commit b19658a78 ("off tag hardcode", 27Jun2024) và được gỡ hẳn khi chuẩn hoá module TH.
 */
const TagTypeProps = {
  default: {
    border: '1px solid #000',
    color: '#000',
  },

  // Consumer duy nhất: src/components/mocules/TagType (chip "cận date" kèm ngày ở giỏ hàng/đơn hàng).
  NEAR_EXPIRATION: {
    code: 'NEAR_EXPIRATION',
    tcode: 'NEAR_EXPIRATION',
    name: 'Cận date',
    textColor: '#DC5C00',
    backgroundColor: '#FFEEEF',
    index: 100,
    url: '/products',
  },
};

export default TagTypeProps;
